import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import api from "@/lib/api";
import { SectionHeading, revealProps } from "@/components/lux";

export default function FaqSection() {
  const [faqs, setFaqs] = useState([]);
  useEffect(() => {
    api.get("/faqs").then((r) => setFaqs(r.data)).catch(() => {});
  }, []);

  return (
    <section className="relative py-24 sm:py-32 bg-[#0b0d12] grain" data-testid="faq-section">
      <div className="mx-auto max-w-[820px] px-5 sm:px-8">
        <motion.div {...revealProps()}>
          <SectionHeading align="center" eyebrow="Good To Know" title="Frequently Asked" />
        </motion.div>
        <motion.div {...revealProps(0.1)} className="mt-12">
          <Accordion type="single" collapsible className="space-y-3">
            {faqs.map((f, i) => (
              <AccordionItem
                key={f.id}
                value={f.id}
                className="border border-white/10 rounded-xl bg-[#12141C] px-5 data-[state=open]:border-[#02AACF]/50 transition-colors"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="text-left text-white hover:no-underline font-display font-semibold text-base py-5">
                  {f.question}
                </AccordionTrigger>
                <AccordionContent className="text-[#94A3B8] leading-relaxed pb-5">{f.answer}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
}
